import { InputGroup } from "@blueprintjs/core";
import React, { useState } from "react";

import { useCreateTeamMutation } from "../../redux/slices";
import { Button } from "../Button/button";
import { Modal } from "../modal/modal";
import styles from "./create-team-modal.module.scss";

export interface CreateTeamModalProps {
  show: boolean;
  handleClose: () => void;
}

const CreateTeamModal = ({ show, handleClose }: CreateTeamModalProps) => {
  const [teamName, setTeamName] = useState<string>("");
  const [createTeam] = useCreateTeamMutation();

  const handleCreateTeam = () => {
    createTeam({ name: teamName });
    handleClose();
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleCreateTeam();
    }
  };

  return (
    <Modal
      title="CREATE TEAM"
      isOpen={show}
      onClose={handleClose}
      actions={[
        <Button intent="danger" text="Cancel" onClick={handleClose} minimal={true} key={1} />,
        <Button intent="primary" text="Create" onClick={handleCreateTeam} key={2} disabled={teamName.length === 0} />,
      ]}
    >
      <InputGroup
        placeholder="Enter Team Name"
        leftIcon="add"
        value={teamName}
        onChange={(e) => setTeamName(e.target.value)}
        onKeyDown={handleKeyDown}
        className={styles.input}
      />
    </Modal>
  );
};

export default CreateTeamModal;
